// First-party request only. Meta's browser script is never loaded on account pages.
const pending = new Map<string, Promise<void>>();
const consentKey = 'cbc-meta-consent-v2';
function currentConsent(): { granted: boolean; time: number } | null {
  try {
    const value = JSON.parse(localStorage.getItem(consentKey) || 'null');
    if (value?.granted === true && Number.isSafeInteger(value.time) &&
        Date.now() >= value.time && Date.now() - value.time < 180 * 86400000) return value;
  } catch (_) { /* Unavailable storage means no advertising request. */ }
  return null;
}
export function reportVerifiedPurchase(sessionId: string): void {
  if (pending.has(sessionId) || !currentConsent()) return;
  const task = (async () => {
    // Retry a transient failure briefly while this page is open; no offline queue.
    for (let attempt = 0; attempt < 3; attempt++) {
      const consent = currentConsent();
      if (!consent) return;
      try {
        const response = await fetch('/memberships/checkout/advertising-purchase', {
          method: 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId, advertising_consent: true,
            consent_version: consentKey, consent_time: consent.time }),
        });
        if (response.ok) {
          const data = await response.json();
          if (data.status !== 'retry') return;
        }
      } catch (_) { /* Measurement failure must never block account setup. */ }
      if (attempt < 2) await new Promise(resolve => setTimeout(resolve, 2000));
    }
  })();
  pending.set(sessionId, task);
}
